/*
A guest booking reference is useless on its own: the API also wants the secret it
issued alongside it, and that secret deliberately never appears in the URL. It
lives in sessionStorage, so refreshing the page still works while a shared,
bookmarked or web-archived link carries nothing that can resolve the booking.

Signed-in bookings need none of this - their reference is bound to the session's
access token, so the URL is already inert for anyone else.
*/
const KEY_PREFIX = 'BOOKING_SECRET_'
export const GUEST_BOOKING_PREFIX = 'guest_'
const GUEST_REF = new RegExp(`${GUEST_BOOKING_PREFIX}[0-9a-f]{32}`)

export const rememberBookingSecret = (bookingRef?: string, secret?: string): void => {
  if (!bookingRef || !secret) return
  try {
    sessionStorage.setItem(`${KEY_PREFIX}${bookingRef}`, secret)
  } catch (e) {
    // Storage can be unavailable (private mode, blocked site data). The booking
    // simply has to be looked up again, which is the safe way to fail.
  }
}

export const bookingSecretFor = (bookingRef: string): string | null => {
  try {
    return sessionStorage.getItem(`${KEY_PREFIX}${bookingRef}`)
  } catch (e) {
    return null
  }
}

// A guest reference reaches the API either in the path or, for /amend/start, in
// the request body.
export const guestBookingRefIn = (...parts: unknown[]): string | undefined => {
  for (const part of parts) {
    if (part === undefined || part === null) continue
    const text = typeof part === 'string' ? part : JSON.stringify(part)
    const found = text?.match(GUEST_REF)?.[0]
    if (found) return found
  }
  return undefined
}
